iScreenWizard.factory('Competentie', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('competentie', params).then(function (response) {
                var competenties = response.data;
                resolve(competenties);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('competentie/'+id).then(function (response) {
                var competentie = response.data;
                resolve(competentie);
            }, reject);
        });
    };

    return data;
});